export const stripTrailingSlash = str => {
  return str.endsWith("/") ? str.slice(0, -1) : str;
};

export const normalizeUrl = str => {
  // removes duplicated and last slash
  return stripTrailingSlash(str.replace(/(\/)\/+/g, "$1"));
};
